import { WorkspaceSubscriptionAccountContactEventRecord } from '../../../../../../../../server-services/query-records/workspace-records';
import { WorkspaceChangeSubscriptionSpecificHandler } from '../types';

export let onModifyAccountContactSubscriptionHandler: WorkspaceChangeSubscriptionSpecificHandler = (
  cache,
  event: WorkspaceSubscriptionAccountContactEventRecord
) => {};
